var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("connection-lost")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c("w-col", { attrs: { xs: "12" } }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$ct("the-connection-to-the-server-is-lost")) +
                    " "
                ),
              ]),
            ],
            1
          ),
          _c(
            "w-row",
            [_c("w-spacer"), _c("w-progress-circular"), _c("w-spacer")],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c("w-spacer"),
          _c(
            "w-button",
            {
              staticClass: "mr",
              attrs: { disabled: _vm.isForceReconnecting },
              on: {
                click: function ($event) {
                  return _vm.forceReconnect()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("force-reconnect")))]
          ),
          _c(
            "w-button",
            {
              staticClass: "cancel",
              on: {
                click: function ($event) {
                  return _vm.logout()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("signout")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }